import { Component, ViewChild } from '@angular/core';
import { OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { UserService } from '../../services/user.service';
import { MessagesService } from '../../services/messages.service';
import { ConfigService } from '../../services/config.service';
import { RoutingService } from '../../services/routing.service';
import { FieldsComponent } from '../fields/fields.component';

/**
 * Main component for managing a user's system account preferences.
 */
@Component({
	selector: 'user-profile',
	templateUrl: './profile.component.html',
	styleUrl: './profile.component.css'
})
export class ProfileComponent implements OnInit, OnDestroy, AfterViewInit {

	@ViewChild('nav') nav!: NgbNav;
	@ViewChild(FieldsComponent) fieldsComponent!: FieldsComponent;

	private messageEventSubscription!: Subscription;
	private userServiceSubscription: Subscription = new Subscription();

	LOCALIZATION: any;
	userPermissions: { [key: string]: any } = {};

	loggedin: boolean = false;
	profileOn: boolean = false;
	changePassword: boolean = false;
	messageCount: number = 0;
	activeTab: string = 'userDetails'; // Default tab

	constructor(
		private messagesService: MessagesService,
		private configService: ConfigService,
		private routingService: RoutingService,
		private userService: UserService
	) {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.loggedin = this.userService.user.loggedin;
		this.userPermissions = this.userService.getUserPermissionsMap();
		this.changePassword = this.configService.getConfig().auth.changePassword;
	}

	ngOnInit(): void {
		this.messageEventSubscription = this.messagesService.broadcastEvent.subscribe((event: string) => {
			if (event === 'messagesReloaded') {
				this.getMessageCount();
			}
		});

		this.userServiceSubscription = this.userService.broadcastEvent.subscribe((eventId: string) => {
			switch (eventId) {
				case 'localizationLoaded':
					this.LOCALIZATION = this.userService.LOCALIZATION;
					break;
				case 'userPrefsUpdate':
					this.userPermissions = this.userService.getUserPermissionsMap();
					break;
				case 'loggedIn':
					this.loggedin = this.userService.user.loggedin;
					break;
				case 'openProfileMessages':
					this.showTab('messages');
					break;
			}
		});

		if (this.userPermissions["ROLE_USER_PROFILE"]) {
			this.profileOn = true;
			this.getMessageCount();
		}
	}

	ngAfterViewInit(): void {
		console.log('Nav:', this.nav); // Should NOT be undefined
		console.log('Nav Items:', this.nav?.items?.map(item => item.id)); // Check available tab IDs
		const params = { ...this.routingService.getQueryParams() };
		setTimeout(() => {
			this.showTab(params['tab'] || 'userDetails');
		});
	}

	ngOnDestroy() {
		if (this.messageEventSubscription) {
			this.messageEventSubscription.unsubscribe();
		}
		if (this.userServiceSubscription) {
			this.userServiceSubscription.unsubscribe();
		}
	}

	getMessageCount(): void {
		this.messagesService.getUserMessagesUnreadCount().then(
			(count: any) => {
				this.messageCount = count;
			},
			(err: any) => {
				console.error("Failed to get user message count", err);
			}
		);
	}

	showTab(id: string = 'userDetails') {
		this.activeTab = id;
		// or directly activate
		if (this.nav) {
			this.nav.select(this.activeTab); // Now works reliably
		}
	}

	saveFieldsAndOrders() : void {
		this.fieldsComponent.saveChanges();
	}
	
}
